import { initialsOf } from "../lib/format";
import { resolveAssetUrl } from "../lib/assets";

export default function Avatar({ name, photoUrl, color = "#C9A84C", size = 44, className = "" }) {
  const initials = initialsOf(name || "");
  const resolved = resolveAssetUrl(photoUrl);
  if (resolved) {
    return (
      <img
        src={resolved}
        alt={name}
        className={`rounded-full object-cover gold-border ${className}`}
        style={{ width: size, height: size }}
        data-testid="avatar-photo"
      />
    );
  }
  return (
    <div
      className={`rounded-full flex items-center justify-center font-serif text-[#0D0D0D] ${className}`}
      style={{
        width: size,
        height: size,
        background: color,
        fontSize: size * 0.38,
        letterSpacing: "0.04em",
      }}
      data-testid="avatar-initials"
    >
      {initials || "ST"}
    </div>
  );
}
